<script setup lang="ts">
const props = defineProps({
  stepPercent: { type: Number, required: true },
  indeterminate: { type: Boolean, default: false },
  isCurrentStep: { type: Boolean, default: false },
  step: { type: String, required: true }
})
</script>

<template>
  <v-row no-gutters align="center" class="mb-2">
    <v-col cols="12" sm="6">
      <span :class="{ 'text-primary': isCurrentStep }"> {{ step }} </span>
    </v-col>

    <v-col cols="12" sm="6">
      <v-row no-gutters class="d-flex align-center">
        <v-col cols="11">
          <v-progress-linear
            :model-value="stepPercent"
            :indeterminate="indeterminate"
            color="primary"
            height="4"
            rounded
          />
        </v-col>
        <v-col cols="1">
          <span class="ml-4">
            <v-icon v-if="stepPercent == 100" color="primary"> mdi-check</v-icon>
          </span>
        </v-col>
      </v-row>
    </v-col>
    <v-col offset="6">
      <v-row no-gutters>
        <v-col cols="11">
          <div class="text-center">
            <strong v-if="stepPercent < 100"></strong>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
